<div class="fs-2 with-close" mat-dialog-title>
    Trier mes listes
    <i class="fa fa-close" (click)="onNoClick()" aria-hidden="true"></i>
</div>
<div mat-dialog-content>
    <div cdkDropListGroup>
        <div class="favlist-reorder" cdkDropList cdkDropListLockAxis="y" cdkDropListOrientation="vertical"
             (cdkDropListDropped)="drop($event)">
            <div *ngFor="let list of listFavorite; index as i">
                <b>{{i}}</b> :
                <div class="favlist-reorder-item" cdkDrag>
                    <div class="placeholder" *cdkDragPlaceholder></div>

                    <ng-container *ngIf="list.share == true">👥 -</ng-container>
                    {{ list.title }}
                </div>
            </div>
        </div>
    </div>

</div>
<div mat-dialog-actions>
    <button (click)="onNoClick()" type="reset" class="btn btn-outline">
        Annuler
    </button>
    <button (click)="onYesClick()" type="submit" class="btn btn-primary">
        <mat-spinner diameter="26" *ngIf="loading"></mat-spinner>
        <ng-container *ngIf="!loading">Valider</ng-container>
    </button>
</div>
